/**
 * SF-153: client-side mirrors of `DragonSystem.java`'s server-side constants (game-server), used
 * only to compute the "Max" button convenience values on the Contribute Gold / Slay the Dragon
 * cards. The server's own `FundDragonAction`/`SlayDragonAction` clamps remain fully authoritative
 * regardless of what these compute — see SF153 spec, Key Implementation Note 9.
 */

/** Mirrors `DragonSystem.DRAGON_MAX_CONTRIBUTION_PCT` — a single province may contribute at most
 *  this fraction of a project's total cost. */
export const DRAGON_MAX_CONTRIBUTION_PCT = 0.34;

/** Mirrors `DragonSystem.DRAGON_SOLDIER_HP_DAMAGE` — HP dealt to the dragon per soldier sent. */
export const DRAGON_SOLDIER_HP_DAMAGE = 1;

/** Mirrors `DragonSystem.DRAGON_SPECIALIST_HP_DAMAGE` — HP dealt to the dragon per specialist sent. */
export const DRAGON_SPECIALIST_HP_DAMAGE = 5;
